import { Typography } from "@mui/material"
import useStyles from "./style"
import { lists } from "../../utils"

const PqrType = ({ pqr }) => {
  const classes = useStyles()

  const pqrTypeIndex = (pqr) => {
    switch (pqr) {
      case "Petición":
        return {
          title: lists.pqrTypeMsg.petition.title,
          text: lists.pqrTypeMsg.petition.text,
        }
      case "Reclamo":
        return {
          title: lists.pqrTypeMsg.claim.title,
          text: lists.pqrTypeMsg.claim.text,
        }
      case "Queja":
        return {
          title: lists.pqrTypeMsg.complaint.title,
          text: lists.pqrTypeMsg.complaint.text,
        }
      case "Solicitud":
        return {
          title: lists.pqrTypeMsg.request.title,
          text: lists.pqrTypeMsg.request.text,
        }
      case "Sugerencia":
        return {
          title: lists.pqrTypeMsg.suggestion.title,
          text: lists.pqrTypeMsg.suggestion.text,
        }
      case "Felicitaciones":
        return {
          title: lists.pqrTypeMsg.congratulations.title,
          text: lists.pqrTypeMsg.congratulations.text,
        }
      default:
        return ""
    }
  }

  return (
    <>
      <Typography variant="h6" className={classes.pqrTitle}>
        {pqrTypeIndex(pqr).title}
      </Typography>
      <Typography variant="subtitle1" className={classes.pqrSubtitle}>
        {pqrTypeIndex(pqr).text}
      </Typography>
    </>
  )
}

export default PqrType
